export default __webpack_public_path__ + "313b7a5792d59247bada411efb8124f9.svg";